import React from 'react';
import team from '../../data/team';
import SectionLabel from '../ui/SectionLabel';
import './Team.css';

const Team: React.FC = () => (
  <section className="section team" id="team">

    <div className="team__head reveal">
      <SectionLabel text="Our Team" />

      <h2 className="team__title">
        The Minds Behind<br />
        <em>Rapidus AI</em>
      </h2>

      <p className="team__sub">
        A passionate team focused on building innovative AI solutions
        across automation, analytics, and intelligent systems.
      </p>
    </div>

    <div className="team__grid">
      {team.map((m, i) => (
        <div
          className={`team-card hoverable reveal reveal-delay-${i}`}
          key={m.id}
        >
          <div className="team-card__avatar">
            {m.avatar}
          </div>

          <div className="team-card__name">
            {m.name}
          </div>

          <div className="team-card__role">
            {m.role}
          </div>

          <p className="team-card__bio">
            {m.bio}
          </p>
        </div>
      ))}
    </div>

  </section>
);

export default Team;